module.exports = __webpack_public_path__ + "img/video_en.99b7795.jpg";